import { jwtDecode } from "jwt-decode";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  ActivatedRoute,
} from "@angular/router";
import { AuthGuard } from "./auth.guard";
import { ApplicationPool } from "../services/application.pool";
import { User } from "../models/user";
import { ActionService } from "../services/action.service";

@Injectable({
  providedIn: "root",
})
export class GeneralGuard extends AuthGuard {
  static isLoading = 0;
  public constructor(
    private dataPool: ApplicationPool,
    router: Router,
    dataService: ActionService
  ) {
    super(router, dataService);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    return new Promise((resolve) => {
      const permissions = next.data.permissions;
      const alternative = next.data.alternative;

      if (super.canActivate(next, state)) {
        awaitUser(this.dataPool, this.router).then((user) => {
          if (user && user.permissions) {
            if (
              user.permissions.length > 0 &&
              (!permissions ||
                permissions.length == 0 ||
                user.permissions.filter(
                  (p) => permissions.filter((pi) => pi == p.id).length > 0
                ).length > 0)
            ) {
              // permission granted
              resolve(true);
            } else {
              if (alternative) this.router.navigateByUrl(alternative);
              resolve(false);
            }
          }
        });
      } else {
        if (alternative) this.router.navigateByUrl(alternative);
        resolve(false);
      }
    });
  }
}

export async function awaitUser(
  pool: ApplicationPool,
  router: Router
): Promise<User | null> {
  const jwt: any = jwtDecode(pool.Token);
  if (!(jwt?.userId && jwt.exp > Date.now() / 1000)) {
    if (
      !document.location.pathname.startsWith("/public") &&
      !document.location.pathname.startsWith("/my") &&
      !document.location.pathname.startsWith("/login")
    ) {
      router.navigate(["/public"]);
    }
    return;
  }
  let pending = 0;
  do {
    if (document.location.href.endsWith("/login") && pending == 50) {
      return;
    }
    if ((ApplicationPool.prototype as any)?.___data?.User) {
      return pool.User;
    }
    GeneralGuard.isLoading++;
    await delay(100);
    pending++;
    GeneralGuard.isLoading--;
  } while (
    !(document.location.href.endsWith("/login") && pending == 50) &&
    pool.Token != ""
  );
  return null;
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
